import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { SafeAreaView, TouchableWithoutFeedback, View } from 'react-native';

import { getDropdownItems } from './constants';
import { DropdownList } from './List';
import { useDialog } from '@/hooks/useDialog';
import { localLogoutUser, serverLogoutUser } from '@/hooks/useAuth';
import { getAccessToken } from '@/stores/auth/services';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';

function CustomDropdown({
  expanded,
  hideExpandedMenu,
  showLicenseWarning = false,
}) {
  const { navigate } = useNavigation();
  const { showDialog, removeDialog } = useDialog();

  const onLogoutPress = async () => {
    try {
      await serverLogoutUser({ jwt: await getAccessToken() });
      await localLogoutUser();
    } catch (_error) {
      await localLogoutUser();
    } finally {
      removeDialog();
    }
  };

  const onItemPress = useCallback((title) => {
    switch (title) {
      case 'Abmelden':
        showDialog(PREPARED_DIALOGS.logoutDialog(onLogoutPress));
        break;
      case 'Anleitung':
        navigate('Anleitung');
        break;
      case 'Kontakt':
        showDialog(PREPARED_DIALOGS.kontaktDialog());
        break;
      case 'Über die App':
        showDialog(PREPARED_DIALOGS.aboutNeolexonDialog());
        break;
      case 'Einwilligungen':
        navigate('Einwilligungen');
        break;
      case 'Mein Benutzerkonto':
        navigate('PatientAccount');
        break;
      case 'Ergebnisse ansehen':
        navigate('ResultsScreen');
        break;
      case 'Rezeptcode einlösen':
        navigate('DigaCodes');
        break;
      case 'Lizenz buchen':
        showDialog(PREPARED_DIALOGS.selectHealthInsuranceDialog(removeDialog));
        break;
    }
    hideExpandedMenu();
  }, []);

  return (
    !!expanded && (
      <TouchableWithoutFeedback onPress={hideExpandedMenu}>
        <SafeAreaView className="bg-seethrough-dark absolute w-full h-full inset-0 z-10 flex items-end">
          <View className="w-1/4 bg-slate-50 rounded-xl m-2">
            <DropdownList
              onItemPress={onItemPress}
              items={getDropdownItems({ showLicenseWarning })}
            />
          </View>
        </SafeAreaView>
      </TouchableWithoutFeedback>
    )
  );
}

export default CustomDropdown;
